import classNames from "classnames";
import { ReactNode } from "react";
import { formatNumber } from "src/helpers/helpers";
import { GrowthChart } from "src/icons/GrowthChart";

const KpiCard = ({
  title,
  count,
  icon,
  iconWrapperClassName,
}: {
  title: string;
  count: number;
  icon: ReactNode;
  iconWrapperClassName?: string;
}) => {
  const isPositive = true;
  return (
    <div className="flex flex-col p-[21px] rounded-14px bg-white gap-[14px]">
      <div className="flex justify-between">
        <div className="flex flex-col">
          <div className="text-20px font-semibold text-black-coral">
            {title}
          </div>
          <div className="text-26px font-bold text-black-raisin">
            {formatNumber(count)}
          </div>
        </div>
        <div
          className={classNames(
            "flex justify-center items-center w-[64px] h-[64px] rounded-md",
            iconWrapperClassName
          )}
        >
          {icon}
        </div>
      </div>
      <div className="flex gap-2 text-[16px] items-center font-semibold">
        <GrowthChart />{" "}
        <div className="flex items-center gap-2">
          <span
            className={classNames({
              "text-blue-bondi": isPositive,
              "text-red": !isPositive,
            })}
          >
            8.5%
          </span>{" "}
          <span className="text-black-coral">Up from yesterday</span>
        </div>
      </div>
    </div>
  );
};

export default KpiCard;
